import Cookies from 'js-cookie';
import { apiAction } from '../utils/index';

import {
  UNITOVERVIEW_ERROR,
  SET_UNITOVERVIEW_SETTINGS,
  UNITOVERVIEW_IS_LOADING,
  SET_UNITOVERVIEW_DATA,
  UNITOVERVIEW_CLEANUP
} from '../constants/index';

const envName = process.env.REACT_APP_ENV_NAME_SHORT;

export const setUnitOverviewErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setUnitOverviewError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setUnitOverviewError(messageCode, false));
  }, 2500);
};

export const setUnitOverviewError = (messageCode, status) => {
  return {
    type: UNITOVERVIEW_ERROR,
    payload: {
      data: {
        isOpSuccessful: false,
        showBanner: status,
        isLoading: false,
        displayMessageCode: messageCode || ''
      }
    }
  };
};

export const setLoadingStatus = isLoading => ({
  type: UNITOVERVIEW_IS_LOADING,
  payload: { isLoading: isLoading }
});

export const getUnitOverviewSettingsThunk = (widget, payload) => dispatch => {
  dispatch(getUnitOverviewSettings(widget, payload));
};

export const getUnitOverviewSettings = (widgetCode,payload) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_UNITS}/unit/overview`,
    data: {
      UserId: Cookies.get(`userid-${envName}`) || 0,
      organisationId: Cookies.get(`selectedorganisationid-${envName}`) || 0,
      modelId: payload.modelId,
      unitId: payload.unitId,
      unitSerialNumber: payload.unitSerialNumber || null,
      requireDashboardData: 1
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setUnitOverviewSettingsThunk(retData),
    onFailure: err => setUnitOverviewErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: widgetCode
  });

export const setUnitOverviewSettingsThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let UnitOverview = (retData && retData.data) || {};
  UnitOverview.InitialLoading = false;
  dispatch(setUnitOverviewSettings(messageCode, UnitOverview));
};

export const setUnitOverviewSettings = (messageCode, UnitOverview) => ({
  type: SET_UNITOVERVIEW_SETTINGS,
  payload: {
    data: {
      UnitOverview: UnitOverview.UnitOverview || {},
      isLoading: false,

      displayMessageCode: messageCode,
      showBanner: false,
      isOpSuccessful: false
    }
  }
});


export const getUnitOverviewDataThunk = (widget, payload) => dispatch => {
  dispatch(getUnitOverviewData(widget, payload));
};

  export const getUnitOverviewData = (widgetCode,payload) =>
    apiAction({
      url: `${process.env.REACT_APP_API_ENDPOINT_UNITS}/unit/overview`,
      data: {
        UserId: Cookies.get(`userid-${envName}`) || 0,
        organisationId: Cookies.get(`selectedorganisationid-${envName}`) || 0,
        modelId: payload.modelId,
        unitId: payload.unitId,
        unitSerialNumber: payload.unitSerialNumber || null,
        LastTelemetryTimestamp: payload.LastTelemetryTimestamp || null,
        LastSummaryTimestamp: payload.LastSummaryTimestamp || null,
        requireDashboardData: 0
      },
      method: 'GET',
      onLoad: status => setLoadingStatus(status),
      onSuccess: retData => setUnitOverviewDataThunk(retData),
      onFailure: err => setUnitOverviewErrorThunk(err),
      accessToken: Cookies.get(`access-${envName}`),
      widgetcode: widgetCode
    });
  

export const setUnitOverviewDataThunk = retData => dispatch => {
  let messageCode = retData && retData.message;

  dispatch(setUnitOverviewData(messageCode, retData.data));
};

export const setUnitOverviewData = (messageCode, data) => ({
  type: SET_UNITOVERVIEW_DATA,
  payload: {
    data: {
      data: data,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false
    }
  }
});

export const cleanUpThunk = retData => dispatch => {
  dispatch(cleanUp(retData));
};

export const cleanUp = retData => ({
  type: UNITOVERVIEW_CLEANUP,
  payload: retData
});
